import React from "react";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import { Button, CardText } from "react-bootstrap";
import StatisticResultTable from "./StatisticResultTable";
import MapLegendCustomized from "./MapLegendCustomized";
import POIQueryResultTable from "./POIQueryResultTable";
import DataNote from "./DataNote";

const cardStyle = {
    position: "absolute",
    top: "54px",
    margin: "1em",
    zIndex: 100,
    width: "400px"
};

const ResultCard = ({ ifServiceAreaResolved, serviceAreaStatsQueryResult, poisQueryResult, resetQuery }) => {
    return (
        <Card style={cardStyle}>
            <Card.Body>
                {ifServiceAreaResolved ? (
                    <>
                        <Card.Title>Umfeldanalyse</Card.Title>
                        <Accordion
                            defaultActiveKey="0"
                            flush
                            alwaysOpen
                            className="my-2"
                        >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Statistik</Accordion.Header>
                                <Accordion.Body className="p-0">
                                    <StatisticResultTable
                                        resultArr={serviceAreaStatsQueryResult}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Einrichtungen im Abdeckungsbereich
                                </Accordion.Header>
                                <Accordion.Body className="p-0">
                                    <POIQueryResultTable
                                        poiResult={poisQueryResult}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </>
                ) : (
                    <>
                        <Card.Title>Fehler in der Umfeldanalyse: </Card.Title>
                        <Card.Text>{serviceAreaStatsQueryResult} </Card.Text>
                    </>
                )}
                <MapLegendCustomized />
                <CardText>
                    <DataNote />
                </CardText>
                <Button variant="outline-secondary" onClick={window.print}>
                    Exportieren
                </Button>
                <Button variant="danger" className="mx-2" onClick={resetQuery}>
                    Zurücksetzen
                </Button>
            </Card.Body>
            <Card.Footer>
                <img
                    src="ispace_plus_logo_600dpi.png"
                    alt="ispaceplpus-logo"
                    style={{ width: "35%", marginRight: "25px" }}
                />
                <img
                    src="Salzburg-Verkehr-Logo.png"
                    alt="svv-logo"
                    style={{ width: "43%" }}
                />
            </Card.Footer>
        </Card>
    );
};

export default ResultCard;
